export const notFutureDate = (value) => {
    if (!value) return true;
    const inputDate = new Date(value);
    const today = new Date();
    return inputDate.setHours(0,0,0,0) <= today.setHours(0,0,0,0);
};

export const notOlderThanTwoYears = (value) => {
    if (!value) return true;
    const inputDate = new Date(value);
    const twoYearsAgo = new Date();
    twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2, 0, 1);
    return inputDate.setHours(0,0,0,0) >= twoYearsAgo.setHours(0,0,0,0);
};